(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    /* 251204 동적 렌더링 시 이벤트 미실행 문제 수정 */
    // 중복 실행 방지: 이미 리스너가 등록되어 있다면 종료
    if (window.isGiftTabInitialized) return;
    window.isGiftTabInitialized = true;

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.tab-type__btn');
      if (!btn) return;

      // 클릭된 시점에 현재 살아있는 슬라이더 요소 확인
      const sliderEl = document.getElementById('ui-slider-gift-tab');

      // 슬라이더가 없거나, 클릭된 버튼이 이 슬라이더 내부가 아니면 무시
      if (!sliderEl || !sliderEl.contains(btn)) return;

      if (!sliderEl.swiper) return;

      const slide = btn.closest('.swiper-slide');
      if (!slide) return;

      const index = Array.from(sliderEl.swiper.slides).indexOf(slide);

      if (index >= 0) {
        sliderEl.swiper.slideTo(index, 300);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
